import React from 'react';
import styled from 'styled-components';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { DropdownToggle, DropdownMenu, DropdownItem, Dropdown, FormText } from 'reactstrap';

import routes, { generateLink } from 'utils/routes';
import { useToggle } from 'utils/hooks';
import { CardBody } from 'components/Card';
import { getUser } from 'redux/reducers/sessionReducer';
import { logOut } from 'redux/actions/sessionActions';
import { LOCALIZATION_PAGES } from 'utils/constants';

const HeaderMenu = () => {
  const user = useSelector(getUser);
  const dispatch = useDispatch();
  const history = useHistory();
  const [dropdownOpen, setDropdownOpen] = useToggle(false);
  const { t } = useTranslation(LOCALIZATION_PAGES.LAYOUT);

  const { firstName, lastName, email } = user || {};
  const fullName = firstName && lastName ? `${firstName} ${lastName}` : '-';

  const goToProfile = () => history.push(generateLink(routes.USER_PROFILE));

  const logOutUser = async () => {
    dispatch(logOut());
    await Auth.signOut();
    history.push(routes.SIGNIN.path);
  };

  const menu = [
    {
      iconPath: `${process.env.PUBLIC_URL}/assets/icons/list-outline.svg`,
      label: t('my_profile'),
      onClick: goToProfile,
    },
    {
      iconPath: `${process.env.PUBLIC_URL}/assets/icons/log-out-outline.svg`,
      label: t('sign_out'),
      onClick: logOutUser,
    },
  ];

  return (
    <CustomDropdown isOpen={dropdownOpen} toggle={setDropdownOpen}>
      <CustomToggle color="transparent">
        {user && firstName && lastName && (
          <Initials>
            {firstName[0]}
            {lastName[0]}
          </Initials>
        )}
        <Icon src={`${process.env.PUBLIC_URL}/assets/icons/select.svg`} alt={t('select_icon')} />
      </CustomToggle>
      <DropdownMenu right>
        <DropdownItem header>
          {fullName}
          <FormText>{email}</FormText>
        </DropdownItem>
        <DropdownItem divider />
        {menu.map(m => {
          return (
            <CustomDropdownItem onClick={m.onClick} key={m.label}>
              <CustomImg alt={m.label} src={m.iconPath} />
              <CustomFormText color="dark">{m.label}</CustomFormText>
            </CustomDropdownItem>
          );
        })}
      </DropdownMenu>
    </CustomDropdown>
  );
};

const CustomDropdown = styled(Dropdown)`
  margin-left: 0.8rem;
`;

const CustomDropdownItem = styled(DropdownItem)`
  display: flex !important;
  flex-direction: row;
  align-items: center;
`;

const CustomImg = styled.img`
  margin-right: 0.8rem;
`;

const CustomFormText = styled(FormText)`
  font-size: 14px;
  margin: 0;
`;

const Initials = styled(CardBody)`
  height: 28px;
  width: 28px;
  background-color: var(--secondary);
  color: var(--light);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  border-radius: 100%;
  padding: 0px !important;
  float: left;
  margin: 0px !important;
`;

const CustomToggle = styled(DropdownToggle)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  height: 28px;
  padding: 0px !important;
  border: none;
  box-shadow: none;
  &:hover {
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
  &:active {
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
  &:focus {
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
`;

const Icon = styled.img`
  height: 13px;
  width: 13px;
`;

export default HeaderMenu;
